import React from "react";

// material ui icons
import Check from "@material-ui/icons/Check";
import { Grid, withStyles, Checkbox, FormControlLabel } from "material-ui";

import { ItemGrid, Button } from "components";

import CustomInput from "components/CustomInput/CustomInput.jsx";

// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";

const server = 'https://dappstore.link/';
// const server = 'http://store.zaxid.media/';

class AddDappForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // type validation
            name: "",
            nameState: "",
            email: "",
            emailState: "",
            url: "",
            urlState: "",
            // range validation
            subscribeChecked: true,
        };

    }
    // function that returns true if value is email, false otherwise
    verifyEmail(value) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    }
    // function that verifies if a string has a given length or not
    verifyLength(value, length) {
        if (value.length >= length) {
            return true;
        }
        return false;
    }
    // function that verifies if two strings are equal
    compare(string1, string2) {
        if (string1 === string2) {
            return true;
        }
        return false;
    }
    // function that verifies if value contains only numbers
    verifyNumber(value) {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value)) {
            return true;
        }
        return false;
    }
    // verifies if value is a valid URL
    verifyUrl(value) {
        try {
            new URL(value);
            return true;
        } catch ( _ ) {
            return false;
        }
    }
    change(event, stateName, type, stateNameEqualTo, maxValue) {
        switch (type) {
        case "email":
            if (this.verifyEmail(event.target.value)) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "password":
            if (this.verifyLength(event.target.value, 1)) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "equalTo":
            if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "checkbox":
            if (event.target.checked) {
                this.setState({
                    [stateName + "State"]: ""
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "number":
            if (this.verifyNumber(event.target.value)) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "length":
            if (this.verifyLength(event.target.value, stateNameEqualTo)) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "max-length":
            if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "url":
            if (this.verifyUrl(event.target.value)) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "min-value":
            if (
                    this.verifyNumber(event.target.value) &&
                    event.target.value >= stateNameEqualTo
            ) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "max-value":
            if (
                    this.verifyNumber(event.target.value) &&
                    event.target.value <= stateNameEqualTo
            ) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        case "range":
            if (
                    this.verifyNumber(event.target.value) &&
                    event.target.value >= stateNameEqualTo &&
                    event.target.value <= maxValue
            ) {
                this.setState({
                    [stateName + "State"]: "success"
                });
            } else {
                this.setState({
                    [stateName + "State"]: "error"
                });
            }
            break;
        default:
            break;
        }
        switch (type) {
        case "checkbox":
            this.setState({
                [stateName]: event.target.checked
            });
            break;
        default:
            this.setState({
                [stateName]: event.target.value
            });
            break;
        }
    }

    validation() {
        if (this.state.nameState === "") {
            this.setState({
                nameState: "error"
            });
        }
        if (this.state.emailState === "") {
            this.setState({
                emailState: "error"
            });
        }
        if (this.state.urlState === "") {
            this.setState({
                urlState: "error"
            });
        }
        if (
                this.state.nameState === "success" &&
                this.state.emailState === "success" &&
                this.state.urlState === "success"
        ) {
            return true;
        } else {
            return false;
        }
    }

    subscribeToggle() {
        this.setState({
            subscribeChecked: !this.state.subscribeChecked
        });
    }

    send() {
        if (this.validation()) {
            this.props.onSend();
            fetch(server + 'api/add-dapp', {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                mode: "cors", // no-cors, cors, *same-origin
                credentials: 'include',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: 'name=' + this.state.name + '&email=' + this.state.email + '&url=' + this.state.url + '&subscribe=' + this.state.subscribeChecked,
            });
        }
    }

    render() {
        const {classes} = this.props;
        return (
            <Grid container>

        <ItemGrid xs={12} sm={12} md={12}>

              <form>

                    <CustomInput
            labelText="Name"
            success={this.state.nameState === "success"}
            error={this.state.nameState === "error"}
            id="name"
            formControlProps={{
                fullWidth: true
            }}
            inputProps={{
                onChange: (event) => this.change(event, "name", "length", 0),
                type: "text"
            }}
            />

                    <CustomInput
            labelText="Email"
            success={this.state.emailState === "success"}
            error={this.state.emailState === "error"}
            id="email"
            formControlProps={{
                fullWidth: true
            }}
            inputProps={{
                onChange: event => this.change(event, "email", "email"),
                type: "email"
            }}
            />

                    <CustomInput
            labelText="Site"
            success={this.state.urlState === "success"}
            error={this.state.urlState === "error"}
            id="url"
            formControlProps={{
                fullWidth: true
            }}
            inputProps={{
                onChange: event => this.change(event, "url", "url"),
                type: "url"
            }}
            />

                <div className={classes.checkboxAndRadio}>
                  <FormControlLabel
            control={
            <Checkbox
            tabIndex={-1}
            onClick={ event => this.subscribeToggle()}
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
                checked: classes.checked
            }
            }
            checked={ this.state.subscribeChecked }
            />
            }
            classes={{
                label: classes.label
            }}
            label="Subscribe to newsletter"
            />
                </div>
                <Button color="danger" style={{
                marginRight: '8px'
            }} onClick={ event => this.props.onCancel()}>Cancel</Button>
                <Button color="success" style={{
                marginRight: '8px'
            }} onClick={ event => this.send()}>Send</Button>

              </form>

        </ItemGrid>

      </Grid>
        );
    }
}

export default withStyles(validationFormsStyle)(AddDappForm);



// WEBPACK FOOTER //
// ./src/views/Forms/AddDappForm.jsx